var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":function($event){return _vm.submitHandle()}}},[_vm._v("提交")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }